import * as React from 'react';

export function useScrollTo(elementId: string): void {
  const [wasScrolled, setWasScrolled] = React.useState(false);

  React.useLayoutEffect(() => {
    if (elementId && !wasScrolled) {
      const element = document.getElementById(elementId);
      if (!element) {
        return;
      }

      setWasScrolled(true);
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });
}
